var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer location",attrs:{"title":"Click para abrir en el mapa"},on:{"click":_vm.goLocation}},[_c('img',{attrs:{"src":require("@/app/tickets/assets/placeholder-map.jpg"),"alt":_vm.name}}),_c('p',{staticClass:"link_text2"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }